require('typeface-airbnb-cereal');

// eslint-disable-next-line import/prefer-default-export
export const disableCorePrefetching = () => true;
